export default __webpack_public_path__ + "static/media/q3.7be81904.png";